<template>
	<div class='knd-story'>
		<Header />
		<router-view></router-view>
	</div>
</template>

<script>
	import Header from '@/js/story/header/';	
	import Articles from '@/js/story/articles';

	const vueObject = {
		components: {Header, Articles}
	}

	export default vueObject;
</script>